/**
 * Currency Hook
 * Uses CurrencyCore for business logic
 */
import { useMemo } from 'react';
import { useTagadaContext } from '../providers/TagadaProvider';
import { CurrencyUtils } from '../../core/utils/currency';
export function useCurrency(defaultCurrency = 'USD') {
    const context = useTagadaContext();
    const currency = useMemo(() => {
        return CurrencyUtils.getCurrency(context, defaultCurrency);
    }, [context, defaultCurrency]);
    const format = (amount) => {
        const symbol = currency.symbol || currency.code;
        return `${symbol}${amount.toFixed(currency.decimalPlaces)}`;
    };
    return {
        ...currency,
        format,
    };
}
